import { cardeal } from './api';

export class AlteracaoPercentualContribuicaoService {
  getPercentualAtualParticipante = async (matricula, plano) => {
    const response = await cardeal.get(
      'ObterPercentualContribuicaoParticipante',
      {
        params: {
          matricula,
          plano,
        },
      }
    );
    return response.data.ObterPercentualContribuicaoAtualParticipanteResult
      .Value;
  };

  setMudancaPercentualContribuicaoParticipanteResult = async (values) => {
    const response = await cardeal.post(
      'RegistrarMudancaPercentualContribuicaoParticipante',
      {
        matricula: values.matricula,
        percentualVigente: values.percentualAtual,
        percentualDesejado: values.percentualTroca,
      }
    );
    if (
      response.data.SalvarMudancaPercentualContribuicaoParticipanteResult
        .Value === null
    )
      return true;

    return false;
  };

  getHistoricoIntencaoMudancaPercentualContribuicao = async (matricula) => {
    const response = await cardeal.get(
      'ObterHistoricoIntencaoTrocaPercentualContribuicaoParticipante',
      {
        params: {
          matricula,
        },
      }
    );

    return response.data;
  };

  getHistoricoMudancaPercentualContribuicao = async (matricula) => {
    const response = await cardeal.get(
      'ObterHistoricoMudancaPercentualContribuicaoParticipante',
      {
        params: {
          matricula,
        },
      }
    );

    return response.data;
  };

  getVerificarDisponibilidadeAlterarContribuicao = async (matricula) => {
    const response = await cardeal.get(
      `VerificarDisponibilidadeAlterarContribuicao`,
      {
        params: {
          matricula,
        },
      }
    );

    if (response.data.Disponivel === 0) return false;
    return true;
  };
}
